import { render, staticRenderFns } from "./DrawableBoard.vue?vue&type=template&id=0775f3ba&scoped=true&"
import script from "./DrawableBoard.vue?vue&type=script&lang=js&"
export * from "./DrawableBoard.vue?vue&type=script&lang=js&"
import style0 from "./DrawableBoard.vue?vue&type=style&index=0&id=0775f3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775f3ba",
  null
  
)

export default component.exports